module.exports = __webpack_public_path__ + "static/how_to_walk-fd49b6f5533d39e81c1f2fedd27cb3b5.png";